import React from "react";
import { getBoundingClientRect } from "../../utils/functions";
import { widgetsList } from "../../variables/widgetsList";
import WidgetComponents from "./WidgetComponents";


class WidgetContainer extends React.Component {

    state = {
    }



    render() {

        let Component = WidgetComponents[this.props.data.key]

        if (Component) {
            return (
                <div className="  h-100  pb-1"  >

                    <div className="p-2 h-100 d-flex flex-column" style={{ backgroundColor: '#fff', borderRadius: 4, position: 'relative' }}>

                        <div className="flexc w-100 px-2 pt-2" style={{ position: 'absolute', top: 0, left: 0,}}>
                            <button onClick={() => this.props.openMore(this.props.data,this.props.index)} className="flexcc moreBut px-0 py-1 " style={{opacity:0.5}}>
                                <img className="mrd-0 " draggable={false} src={'/images/more.svg'} height="16px" />
                            </button>

                            {/* <button className="flexcc moreBut px-0 py-1 " style={{zIndex:5}} >
                                <img onDragStart={e => this.props.onDragStart(e)} onDrag={e => this.props.onDrag(e)} className="rotate-90"  src={'https://www.flaticon.com/svg/vstatic/svg/271/271195.svg?token=exp=1612694735~hmac=949c0674cf97cb0ad90203776ecb27da'} height="16px" style={{zIndex:5}} />
                            </button> */}
                            <div className={"px-2 move-indicator"} draggable onDragStart={e => this.props.onDragStart(e)} onDrag={e => this.props.onDrag(e)} style={{opacity:0.5}}>

                            </div>

                        </div>

                        <p className="text-center text-bold mt-1 mb-2 text-small" style={{color:'#9ab'}} >{this.props.data.title}</p>

                        <Component data={this.props.data} dashboard={this.props.dashboard} isEditing={this.props.isEditing}  />

                    </div>
                </div>
            )
        } else {
            return (
                <div></div>
            )
        }
    }
}



export default WidgetContainer;
